import * as React from 'react';
import { IconChevronRight16, IconChevronLeft16 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ICustomSwiperNavigationRef } from '../../../../components/CustomSwiper';

interface IContainerProps {
  description: string;
  carousel: React.ReactNode;
  navRef: ICustomSwiperNavigationRef;
}

export function ClusterLayout({ carousel, description, navRef }: IContainerProps) {
  return (
    <section className={styles['container']} id="cluster">
      <div className={styles['header']}>
        <div className={styles['description']}>{description}</div>
      </div>
      <div className={styles['carousel']}>
        <button className={`${styles['button']} ${styles['prev']}`} type="button" ref={navRef.prev}>
          <IconChevronLeft16 color="gray_icons_100" />
        </button>
        <button className={`${styles['button']} ${styles['next']}`} type="button" ref={navRef.next}>
          <IconChevronRight16 color="gray_icons_100" />
        </button>
        {carousel}
      </div>
    </section>
  );
}
